const DEBUG_MODE = false
const DEBUG_USE_LIVE = true

const DEBUG_URL_LOCAL = 'http://localhost:61813/api/'
const DEBUG_URL_LIVE = 'https://online.extendweather.com/api/'
const DEBUG_URL = DEBUG_USE_LIVE ? DEBUG_URL_LIVE : DEBUG_URL_LOCAL

const VERSION = '1.4.2'
const VERSION_DATE = '04 Oct 2023'

const RELEASE_URL = '/api/'

const DEBUG_LOGGING = true
const RELEASE_LOGGING = false

const DEBUG_RUN_TESTS = true

const DEBUG_USE_SAMPLE_CHART_DATA = false
const RELEASE_USE_SAMPLE_CHART_DATA = false

const DEBUG_USE_SAMPLE_SUMMARY_DATA = false
const RELEASE_USE_SAMPLE_SUMMARY_DATA = false

export default {
    dualPaneThreshold:      900,
    mobilePopupThreshold:   850,
    defaultMapCenter:       [0, 0],
    defaultMapZoom:         6,
    defaultRasterLayerOpacity: 0.8,
    mapBoxAccessToken:      'pk.eyJ1IjoibWF0dGhld2NzIiwiYSI6ImNqbzdueGtqZTB4YXAzcXFtMWR3bnZ4N3YifQ.dD0tbDLoIH81x3twMmjr6w',
    apiUrl:                 DEBUG_MODE ? DEBUG_URL : RELEASE_URL,
    logging:                DEBUG_MODE ? DEBUG_LOGGING : RELEASE_LOGGING,
    useSampleChartData:     DEBUG_MODE ? DEBUG_USE_SAMPLE_CHART_DATA : RELEASE_USE_SAMPLE_CHART_DATA, 
    useSampleSummaryData:   DEBUG_MODE ? DEBUG_USE_SAMPLE_SUMMARY_DATA : RELEASE_USE_SAMPLE_SUMMARY_DATA, 
    version:                VERSION,
    versionDate:            VERSION_DATE,
    runTests:               DEBUG_MODE && DEBUG_RUN_TESTS,
    isDebug() {
        return DEBUG_MODE
    }
}